var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8877 5.76648C9.14321 5.2963 10.5207 4.99988 12 4.99988C19.1857 4.99988 23.981 11.9721 24 11.9999C24 11.9999 22.1104 14.7517 18.9258 16.8046L22.4141 20.2928L21 21.7069L3 3.70691L4.41406 2.29285L7.8877 5.76648ZM7.2666 10.3876C7.09433 10.8935 7.00001 11.4357 7 11.9999C7 14.7613 9.23858 16.9999 12 16.9999C12.5183 16.9999 13.0181 16.9207 13.4883 16.7743L15.2725 18.5155C14.2501 18.8185 13.1561 18.9999 12 18.9999C4.8 18.9999 0 11.9999 0 11.9999C0.0111644 11.9836 1.66331 9.58197 4.47559 7.59656L7.2666 10.3876ZM12 6.99988C11.1655 6.99988 10.379 7.20472 9.6875 7.56628L11.2236 9.10242C11.4712 9.03606 11.7314 8.99988 12 8.99988C13.6568 8.99988 14.9999 10.3431 15 11.9999C15 12.2683 14.9628 12.528 14.8965 12.7753L16.4326 14.3114C16.7944 13.6202 17 12.8343 17 11.9999C16.9999 9.23851 14.7614 6.99988 12 6.99988ZM9.04297 12.1639L9.43848 13.5546C9.18258 13.1338 9.02421 12.6471 9.00293 12.1239L9.04297 12.1639Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionHide);
export default __webpack_public_path__ + "static/media/ic_action_hide.84d56a754ac48dd5c0a176e54af1348a.svg";
export { ForwardRef as ReactComponent };